import { render, staticRenderFns } from "./ProjectOutputTable.vue?vue&type=template&id=fd2c6c4e&scoped=true"
import script from "./ProjectOutputTable.vue?vue&type=script&lang=ts"
export * from "./ProjectOutputTable.vue?vue&type=script&lang=ts"
import style0 from "./ProjectOutputTable.vue?vue&type=style&index=0&id=fd2c6c4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2c6c4e",
  null
  
)

export default component.exports